
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[[...slug]]",
      function () {
        return require("private-next-pages/shop/[[...slug]].tsx");
      }
    ]);
  